import React from "react";
import { ArrowRightIcon, LockIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
type CTAButtonProps = {
  label: string;
  id?: string;
  note?: string | null;
  tone?: "light" | "dark";
};
export function CTAButton({
  label,
  id,
  note = "Secure checkout · One-time payment of $27",
  tone = "light"
}: CTAButtonProps) {
  return <div className="flex w-full flex-col items-center" data-id="element-27" data-mp="2g1y0mf9bltm2">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-coral px-5 py-5 text-center font-display text-[17px] font-bold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_#b2330f] transition-[transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:shadow-[0_8px_0_#b2330f] focus:outline-none focus-visible:ring-4 focus-visible:ring-sun active:translate-y-1 active:shadow-[0_2px_0_#b2330f] sm:text-xl" data-id="element-28" data-mp="2ty1qxxh2pht9">
        <span className="text-balance" data-id="element-29" data-mp="38m60oby5eizw">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-30" data-mp="199obk6wc8roj" />
      </a>
      {note && <p className={`mt-3 flex items-center justify-center gap-1.5 text-center text-sm font-bold ${tone === "dark" ? "text-white/80" : "text-ink/70"}`} data-id="element-31" data-mp="1i9beix4pu5jp">
          <LockIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-32" data-mp="1s8k4zg0dh21b" />
          {note}
        </p>}
    </div>;
}